var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"details-section",class:{ borderless: _vm.noBorder, readonly: _vm.readonly }},[(_vm.$slots && _vm.$slots.header)?_c('SectionHeader',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }